import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const RZP_SRC = "https://checkout.razorpay.com/v1/checkout.js";

export const loadRazorpayScript = () =>
  new Promise((resolve) => {
    if (document.getElementById("razorpay-sdk")) return resolve(true);
    const s = document.createElement("script");
    s.id = "razorpay-sdk";
    s.src = RZP_SRC;
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });

export const razorpayApi = {
  config: () => axios.get(`${API}/razorpay/config`),
  plans: () => axios.get(`${API}/razorpay/plans`),
  createOrder: (data) => axios.post(`${API}/razorpay/create-order`, data),
  verifyPayment: (data) => axios.post(`${API}/razorpay/verify-payment`, data),
  transactions: (merchantId) => axios.get(`${API}/razorpay/transactions/${merchantId}`),
  wallet: (merchantId) => axios.get(`${API}/razorpay/wallet/${merchantId}`),
  subscription: (merchantId) => axios.get(`${API}/razorpay/subscription/${merchantId}`),
};

/**
 * Launches Razorpay Checkout and returns a Promise that resolves with the
 * verified payment response, or rejects on failure/cancel.
 */
export const openRazorpayCheckout = async ({
  amount,
  currency = "INR",
  purpose,
  merchantId,
  merchantName = "AURUM GATEWAY",
  customerName = "",
  customerEmail = "",
  customerContact = "",
  note = "",
  planId = "",
}) => {
  const ok = await loadRazorpayScript();
  if (!ok) throw new Error("Razorpay SDK failed to load. Check internet connection.");

  const { data: cfg } = await razorpayApi.config();
  if (!cfg.configured) {
    throw new Error(
      "Razorpay not configured. Please add your Razorpay keys in backend/.env — see guide on the Online Pay screen."
    );
  }

  const { data: order } = await razorpayApi.createOrder({
    amount,
    currency,
    purpose,
    merchantId,
    customerName,
    customerEmail,
    customerContact,
    note,
    planId,
  });

  return new Promise((resolve, reject) => {
    const options = {
      key: order.key_id,
      amount: order.amount_paise,
      currency: order.currency,
      order_id: order.razorpay_order_id,
      name: merchantName,
      description: note || purpose.replace("_", " "),
      prefill: {
        name: customerName,
        email: customerEmail,
        contact: customerContact,
      },
      theme: {
        color: "#E6B455",
      },
      handler: async (response) => {
        try {
          const { data: verified } = await razorpayApi.verifyPayment({
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
            orderDocId: order.orderDocId,
          });
          resolve(verified);
        } catch (e) {
          reject(e);
        }
      },
      modal: {
        ondismiss: () => reject(new Error("Payment cancelled")),
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.on("payment.failed", (resp) => reject(new Error(resp.error?.description || "Payment failed")));
    rzp.open();
  });
};
